export default __webpack_public_path__ + "static/media/video-2.fa68f5a4.mp4";